import Vue from "vue";
import Vuex from "vuex";
import axiosSurface, { axiosApi } from "./axios";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    facets: null,
    products: null,
    giftcards: null,
    settings: null,
    dict: {},
    contextId: window.umbracoContext?.id,
    categoryId: window.umbracoContext?.categoryId,
    refreshing: true,
    collectionMode: false,
    query: null,
    sortOrder: "default"
  },

  mutations: {
    PRODUCTS(state, value) {
      state.products = value;
    },
    DICT(state, value) {
      state.dict = value;
    },
    FACETS(state, value) {
      let _facets;
      if (value.single) {
        _facets = [...state.facets];
        let _facet = _facets.filter((f) => f.id === value.facetId);
        _facet[0].options.forEach((option) => {
          if (option.id === value.option.id) {
            option.selected = value.selected;
          }
        });
      } else {
        _facets = value;
      }
      state.facets = _facets;
    },

    SETTINGS(state, value) {
      state.settings = value;
    },
    REFRESHING(state, value) {
      state.refreshing = value;
    },
    COLLECTIONMODE(state, value) {
      state.collectionMode = value;
    },
    SORTORDER(state, value) {
      state.sortOrder = value;
    },
    QUERY(state, value) {
      state.query = value;
    }
  },

  getters: {
    selected: (state) => {
      let selected = [];
      state.facets.forEach((facet) => {
        facet.options.forEach((option) => {
          if (option.selected) {
            selected.push({ [facet.id]: option.id });
          }
        });
      });
      return selected;
    }
  },

  actions: {
    dictionary: ({ commit, state }) => {
      axiosApi
        .get("searchapi/productsdictionary?contextid=" + state.contextId)
        .then((response) => {
          commit("DICT", response.dictionary);
        })
        .catch((error) => {
          console.warn(error);
        });
    },

    search: ({ commit, dispatch, state, getters }, data) => {
      data.contextId = state.contextId;
      data.sortOrder = state.sortOrder;
      data.categoryId = state.categoryId;
      data.query = state.query;
      data.selectedFacets = JSON.stringify(
        data.selectedFacets || getters.selected
      );
      commit("REFRESHING", true);

      return new Promise((resolve) => {
        axiosSurface
          .post("search/products", data)
          .then((response) => {
            commit("FACETS", response.facets);
            commit("PRODUCTS", response.products);
            commit("SETTINGS", response.settings);
            commit("REFRESHING", false);
            resolve(response);
            if (!data.preventUrlUpdate) dispatch("updateUrl");
          })
          .catch((error) => {
            console.warn(error);
          });
      });
    },

    reset: ({ commit, state }) => {
      let _facets = [...state.facets];
      _facets.forEach((facet) => {
        facet.options.forEach((option) => {
          option.selected = false;
        });
      });
      commit("FACETS", _facets);
    },

    updateUrl: ({ getters }) => {
      var urlParams = new URLSearchParams(window.location.search);

      var entries = [...urlParams];
      for (let index = 0; index < entries.length; index++) {
        const element = entries[index];
        var key = element[0];
        var value = element[1];
        let isFacetParam = key.indexOf("FACET_") === 0;
        if (isFacetParam) {
          urlParams.delete(key);
        }
      }

      // For some reason, foreaching through key/values pairs in the URLSearchParams object can sometimes skip entries
      // It's very curious, and I haven't been able to find a reason why, left the original code in, in case an expert someday can explain the mystery
      // Mads (mkr)
      // urlParams.forEach((value, key) => {
      //     console.log(key, value, "tester");
      //     let isFacetParam = (key.indexOf('FACET_') === 0);
      //     if (isFacetParam) {
      //         urlParams.delete(key);
      //     }
      // })

      getters.selected.forEach((item) => {
        urlParams.append(Object.keys(item)[0], Object.values(item)[0]);
      });

      urlParams.sort();

      var searchQuery = "?" + urlParams.toString();

      if (searchQuery !== "?") {
        history.replaceState(null, "", searchQuery);
      } else {
        history.replaceState(null, "", location.pathname);
      }
    }
  }
});

export default store;
